<template>
  <div class="top_title">
    <div class="top_name title_size flex relative">
      <div class="flex_1" v-html="name"></div>
      <div class="btn-main flex_1" @click="toggleChecked()">
        <div>{{ buttonName }}</div>
        <transition name="slide-fade">
          <div class="select_icon" :class="[className]">
            <img :src="imageLists.dropdown" alt="" />
          </div>
        </transition>
      </div>
      <transition name="slide-fade">
        <div class="select_option" v-show="option_show">
          <div
            class="option"
            v-for="(list, index) of selectCheckedList"
            :key="index"
          >
            <div @click.stop="chooseInput(list.type)" class="flex align_center">
              <div class="option_name" :style="{color: list.checked?'#0096E3':'#ffffff'}">{{ list.name }}</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 生产状态 -->
    <div class="output_status">
      <img :src="imageLists.divider" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Top",
  emits:["update:currentSelect"],
  data() {
    return {
      option_show: false,
      imageLists: {
        divider: require("@/assets/icon-font/icon-divider.svg"),
        dropdown: require("@/assets/icon-font/icon-dropdown.svg")
      }
    };
  },
  props: {
    className:{
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    buttonName: {
      type: String,
      default: ""
    },
    currentSelect: {
      type: String,
      default: ""
    },
    deviceCurrentSelect: {
      type: String,
      default: ""
    },
    currentType: {
      type: String,
      default: "1"
    },
    checkedList:{
      type:Array,
      default:()=>{
        return []
      }
    },
  },
  computed: {





    selectCheckedList() {
      return this.checkedList
    }
  },
  watch: {
    option_show(val) {
      let dom = document.getElementsByClassName(this.className);
      if (val) {
        dom[0].classList.add("rotate");
      } else {
        dom[0].classList.remove("rotate");
      }
    }
  },
  methods: {
    chooseInput(type) {
        this.$emit("update:currentSelect", type);
      this.selectCheckedList.forEach(select => {
        if (type == select.type) {
          select.checked = true;
        } else {
          select.checked = false;
        }
      });
      this.toggleChecked();
    },
    toggleChecked() {
      this.option_show = !this.option_show;
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../assets/scss/common.scss");
.top_title {
  width: 100%;
  line-height: 20px;
}
.top_name {
  display: flex;
  align-items: center;
}

.btn-main {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  .select_icon {
    width: 12px;
    margin-left: 10px;
    background-size: cover;
    background-repeat: no-repeat;
    &.rotate {
      transform: rotate(180deg);
    }
  }
}
.select_option {
  max-height: 250px;
  overflow: auto;
  font-size: 14px;
  background-color: #000;
  border: 1px solid #2c2c2c;
  border-radius: 10px;
  box-sizing: border-box;
  z-index: 8;
  position: absolute;
  top: 100%;
  right: 0;
  .option {
    padding: 10px;
    &:nth-of-type(1) {
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
    }
    &:hover {
      cursor: pointer;
      background-color: #062323;
    }
  }

}

.output_status {
  width: 100%;
  line-height: 10px;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
